module.exports = __webpack_public_path__ + "img/theory.f7c4c7f6.svg";